import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { backend } from '@shared/datastore/core';
import { projectFeedFailingContestsBackend } from './project-feed-failing-contests.backend';
// import { DatastoreBackendModule } from '@shared/datastore/core';
import { projectFeedFailingContestsReducer } from './project-feed-failing-contests.reducer';

// FIXME: remove that
backend.projectFeedFailingContests = projectFeedFailingContestsBackend;

@NgModule({
  imports: [
    StoreModule.forFeature(
      'projectFeedFailingContests',
      projectFeedFailingContestsReducer,
    ),
    /* DatastoreBackendModule.forFeature(
      'projectFeedFailingContests',
      projectFeedFailingContestsBackend,
    ),*/
  ],
})
export class DatastoreProjectFeedFailingContestsModule {}



// WEBPACK FOOTER //
// ./src/app/@shared/datastore/project-feed-failing-contests/project-feed-failing-contests.module.ts